import { render, staticRenderFns } from "./hlj-footer.vue?vue&type=template&id=46c55500&scoped=true"
import script from "./hlj-footer.vue?vue&type=script&lang=js"
export * from "./hlj-footer.vue?vue&type=script&lang=js"
import style0 from "./hlj-footer.vue?vue&type=style&index=0&id=46c55500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c55500",
  null
  
)

export default component.exports